module.exports = "<div class=\"carousel\">\r\n\t<!-- Templates -->\r\n\t<div class=\"carousel-template\" ng-include=\"$ctrl.templates[$ctrl.index]\"></div>\r\n\r\n\t<!-- Carousel Buttons -->\r\n\t<div class=\"carousel-buttons flex-row\">\r\n\t\t<i class=\"carousel-button btr bt-angle-left fast\" ng-click=\"$ctrl.previousTemplate()\"></i>\r\n\t\t<span class=\"flex\"></span>\r\n\t\t<i class=\"carousel-button btr bt-angle-right fast\" ng-click=\"$ctrl.nextTemplate()\"></i>\r\n\t</div>\r\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./app/common/carousel.html
 ** module id = 20
 ** module chunks = 0
 **/